import {Component, Input, OnInit} from '@angular/core';
import {AccessService, LocalStoreService, StoreSelectorsService} from "../../services";
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {map, switchMap} from "rxjs/operators";
import {compareIds} from "../../common";
import {TutorialsComponent} from "../tutorials/tutorials.component";
import {MatDialog} from "@angular/material/dialog";
import {TutorialsService} from "../../services/tutorials.service";
import {of} from "rxjs";
import {Lib} from "../../../libs/Lib";

@Component({
    selector: 'app-video-link',
    templateUrl: './video-link.component.html',
    styleUrls: ['./video-link.component.scss']
})
export class VideoLinkComponent extends Compbaser implements OnInit {

    m_videoLink: string;
    m_toolTip: string;
    m_show = false;
    watched = false;
    blinking = false;
    private autoWatchTimer: any;


    @Input() lessonMode = false;

    @Input() iconButton = false;
    @Input() miniButton = false;
    @Input() callback: (() => void) | null = null; // Optional callback function
    @Input() videoHelpClass = '';
    @Input() opacity = 0.8;
    @Input() showBalloon = false;


    @Input()
    set videoLink(i_videoLink: string) {
        const link = i_videoLink.replace(/\/help\//, '');
        switch (link) {
            case 'Instagram business':
            case 'X':
            case 'LinkedIn':
            case 'Tiktok':
            case 'Google Business':
            case 'Reddit':
            case 'Telegram':
            case 'YouTube stream':
            case 'Facebook':
            case 'Facebook Groups':
            case 'Pinterest': {
                this.m_videoLink = '/help/socials';
                break;
            }
            case '/help/Stock Item': {
                this.m_videoLink = '/help/Stocks';
                break;
            }
            case '/help/Item': {
                this.m_videoLink = '/help/JsonItem';
                break;
            }
            default: {
                this.m_videoLink = i_videoLink;
            }
        }
    }

    constructor(protected override dialog: MatDialog,
                private storeSelector: StoreSelectorsService,
                private translocoService: TranslocoService,
                private accessService: AccessService,
                private localStoreService: LocalStoreService,
                private tutorialsService: TutorialsService) {
        super();
        this.cod(
            this.storeSelector.getUser().pipe(
                switchMap(i_user => {
                    const accountVersion = Lib.GetAccountVersion(i_user);
                    if (accountVersion == 'FREE' || accountVersion == 'PLUS' || accountVersion == 'DASH') {
                        return this.accessService.getGroupsCollection("SignStudio Help").pipe(
                            switchMap(value => {
                                if (value == null || value.$.visible == '1') {
                                    return this.storeSelector.getLocalStoreUpdates().pipe(
                                        map(a => {
                                            const showHelpEnabled = this.localStoreService.getStorageValConfig('showHelpEnabled');
                                            this.m_show = compareIds(1, showHelpEnabled);

                                            const watchedVideoLinks = this.localStoreService.getStorageValConfig('watchedVideoLinks');
                                            if (watchedVideoLinks != null) {
                                                this.watched = (watchedVideoLinks[this.m_videoLink] != null);
                                                this.blinking = !this.watched;
                                            }

                                            // Start auto-watch timer if balloon is shown and not already watched
                                            if (this.showBalloon && !this.watched) {
                                                this.startAutoWatchTimer();
                                            }
                                        })
                                    );
                                } else {
                                    this.m_show = false;
                                    return of(null);
                                }
                            })
                        );
                    } else {
                        this.m_show = false;
                        return of(null);
                    }
                    return accountVersion;
                })
            ).subscribe()
        );
    }

    ngOnInit(): void {
        this.cod(
            this.tutorialsService.getData().subscribe(data => {
                const id = this.m_videoLink.replace(/\/help\//, '');
                if (this.tutorialsService.videoIds[id] != null) {
                    this.m_toolTip = this.tutorialsService.videoIds[id].name;
                }
            })
        );
    }


    onAnimationEnd(): void {
        this.blinking = false;
    }

    openDialogVideo(event) {
        event.stopPropagation();

        // Clear auto-watch timer since user clicked
        this.clearAutoWatchTimer();

        // Mark as watched immediately when clicked
        this.markAsWatched();

        if (this.callback) {
            this.callback(); // Invoke the callback function if provided
        } else {
            const link = this.m_videoLink.replace(/\/help\//, '');
            const dialogRef = this.dialog.open(TutorialsComponent, {
                width: '100vw',
                maxWidth: '100vw',
                height: '100vh', // optional if you also want full height
                panelClass: 'full-width-dialog',
                data: {videoLink: link, lessonMode: this.lessonMode}
            });
        }
    }

    private startAutoWatchTimer() {
        // Clear any existing timer
        this.clearAutoWatchTimer();

        // Set 10 second timer to auto-mark as watched
        this.autoWatchTimer = setTimeout(() => {
            this.markAsWatched();
        }, 10000); // 10 seconds
    }

    private clearAutoWatchTimer() {
        if (this.autoWatchTimer) {
            clearTimeout(this.autoWatchTimer);
            this.autoWatchTimer = null;
        }
    }

    private markAsWatched() {
        if (!this.watched) {
            // Get current watched video links
            let watchedVideoLinks = this.localStoreService.getStorageValConfig('watchedVideoLinks') || {};

            // Mark this video as watched
            watchedVideoLinks[this.m_videoLink] = true;

            // Save back to local storage
            this.localStoreService.setStorageValConfig('watchedVideoLinks', watchedVideoLinks);

            // Update component state
            this.watched = true;
            this.blinking = false;
        }
    }

    override ngOnDestroy() {
        // Clean up timer on component destruction
        this.clearAutoWatchTimer();
        super.ngOnDestroy();
    }
}

